export enum CurriculumSource
{
    Magazine = 1,
    Book = 2,
    Article = 3,
    Patent = 4,
    Other = 5
}